import React, { useEffect, useState } from "react";
import { Table, Input } from "antd";

export interface DatatableProps {
  columns: any[]; // Replace `any` with your data row type if known
  dataSource: any[]; // Can be replaced with a stricter type
  Selection?: boolean; // Optional property for selection state
  setDataSource?: (data: any[]) => void; // Function to update dataSource
  pageSize: number;
  pageSizeOptions?: number[];
  withSearch?: boolean;
  withPagination?: boolean;
}

const NewDatatable: React.FC<DatatableProps> = ({
  columns,
  dataSource,
  Selection,
  pageSize = 10,
  pageSizeOptions = [10, 20, 30],
  withSearch = false,
  withPagination = false,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [searchText, setSearchText] = useState<string>("");
  const [Selections, setSelections] = useState<boolean>(false);
  const [filteredDataSource, setFilteredDataSource] = useState(dataSource || []);

  const onSelectChange = (newSelectedRowKeys: any[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    // Filter data as soon as input is entered
    const filteredData = dataSource.filter((record) =>
      Object.values(record).some((field) =>
        String(field).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredDataSource(filteredData);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  useEffect(() => {
    if (Selection !== undefined) {
      setSelections(Selection);
    }
  }, [Selection]);

  useEffect(() => {
    setFilteredDataSource(dataSource);
  }, [dataSource]);

  return (
    <>
      {withSearch && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 16px",
            marginBottom: 16,
          }}
        >
          <div style={{ flex: 1, marginRight: 16 }}>
            <Input
              placeholder="Search..."
              value={searchText}
              onChange={(e) => handleSearch(e.target.value)}
              style={{ width: "100%" }}
            />
          </div>
        </div>
      )}

      {Selections ? (
        // Render table with checkboxes if Selections is true
        <Table
          className="table datanew dataTable no-footer"
          rowSelection={rowSelection}
          columns={columns}
          dataSource={filteredDataSource}
          pagination={
            withPagination
              ? { pageSize, pageSizeOptions, showSizeChanger: true }
              : false
          }
        />
      ) : (
        // Render table without checkboxes by default
        <Table
          className="table datanew dataTable no-footer"
          columns={columns}
          dataSource={filteredDataSource}
          pagination={
            withPagination
              ? { pageSize, pageSizeOptions, showSizeChanger: true }
              : false
          }
        />
      )}
      {/* <Table
        className="table datanew dataTable no-footer"
        columns={columns}
        rowHoverable={false}
        dataSource={filteredDataSource}
        rowSelection={Selections ? rowSelection : undefined}
        pagination={
          withPagination
            ? { pageSize, pageSizeOptions, showSizeChanger: true }
            : false
        }
      /> */}
    </>
  );
};

export default NewDatatable;